module.exports = __webpack_public_path__ + "static/media/view-show.1bcd0ba0.svg";